import React, { useEffect } from 'react';
import { Phone, Star } from 'lucide-react';
import { FinalCTA } from '../components/home/FinalCTA';
import { Button } from '../components/ui/Button';
import { useDrawers } from '../contexts/DrawerContext';
const CREDENTIALS = ['LL.B', 'B.A', 'LLM', 'Commercial Law Accredited Specialist'];
export function Team() {
  const {
    openQuote
  } = useDrawers();
  useEffect(() => {
    document.title = 'The Legal Team | L.A Property Law & Conveyancing';
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-687" data-mp="12emsabcnr07q">
      <section className="bg-background px-5 py-8 md:px-6 md:py-10" data-id="element-688" data-mp="12ed5sxqtnb6s">
        <div className="mx-auto max-w-7xl" data-id="element-689" data-mp="ngujs35j3c31">
          <div className="mb-6 md:mb-8 max-w-2xl" data-id="element-690" data-mp="ni5hpmcalpm8">
            <p className="eyebrow text-brand-blue" data-id="element-691" data-mp="sew1okr7x5cx">the legal team</p>
            <h1 className="mt-3 font-serif text-4xl leading-[1.08] text-ink md:text-5xl lg:text-6xl" data-id="element-692" data-mp="sh8n57w6pxuq">
              Legal advice from people you can identify.
            </h1>
            <p className="mt-5 text-lg leading-relaxed text-muted-ink" data-id="element-693" data-mp="2msnfzxkhsdep">
              You will know who is handling your matter. That is the value of a
              lawyer-led practice with personal communication.
            </p>
          </div>

          <div className="grid items-start gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-694" data-mp="2jwrn6o6ed0vm">
            <aside className="border-t-4 border-peach bg-ink p-6 text-cream" data-id="element-695" data-mp="2ex6ngbjekohu">
              <p className="font-serif text-7xl leading-none text-white/15" data-id="element-696" data-mp="2ez9nloe9ry0a">LA</p>
              <div className="mt-8 flex items-center gap-1 text-peach" data-id="element-697" data-mp="1r847d84f33pg">
                {[...Array(5)].map((_, index) => <Star key={index} className="h-4 w-4" fill="currentColor" data-id="element-698" data-mp="1mauaj7ep7prl" data-mpi={index} />)}
              </div>
              <p className="mt-3 font-semibold text-cream" data-id="element-699" data-mp="1w6oy8gxs4b18">5.0 Google rating</p>
              <p className="mt-1 text-sm text-cream/60" data-id="element-700" data-mp="1w8ryruwk5mk7">10 reviews</p>
            </aside>

            <div data-id="element-701" data-mp="3blmgwipmvi08">
              <h2 className="font-serif text-3xl text-ink" data-id="element-702" data-mp="3bpa5r4k4vg8m">Linda Ashley</h2>
              <p className="mt-1 font-semibold text-accent" data-id="element-703" data-mp="37lknsxxyrwwk">Principal Solicitor</p>
              <p className="mt-5 text-lg leading-relaxed text-muted-ink" data-id="element-704" data-mp="24a57pdrfa8ha">
                Linda's associated firm profile describes experience across
                property, commercial transactions, trusts, SMSFs, contracts and
                related disputes. That breadth means a property matter that
                turns into something more complex stays in capable hands.
              </p>

              <div className="mt-6 flex flex-wrap gap-2" data-id="element-705" data-mp="1llqhutsud0i2">
                {CREDENTIALS.map(credential => <span key={credential} className="inline-flex items-center rounded-full border border-border bg-soft-panel px-3 py-1.5 text-sm font-medium text-ink" data-id="element-706" data-mp="1qjry76yvulpu">
                    {credential}
                  </span>)}
              </div>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-707" data-mp="12s4n9yi0nl97">
                <Button onClick={openQuote} variant="accent" size="lg" data-id="element-708" data-mp="16tzpr6boo4ok">
                  Get a free quote
                </Button>
                <a href="tel:+61386172600" data-id="element-709" data-mp="ucxaym9p7g0a">
                  <Button variant="outline" size="lg" data-id="element-710" data-mp="ue01gt33zgfo">
                    <Phone className="h-4 w-4" data-id="element-711" data-mp="qbbqofuu3zg2" />
                    Call (03) 8617 2600
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FinalCTA data-id="element-712" data-mp="gcw14hbggy8o" />
    </main>;
}